// extracted by css-extract-rspack-plugin
export default {"container":"gJHfG","divider":"gKlA0"};